import { render, staticRenderFns } from "./ObjectStoreActions.vue?vue&type=template&id=3ae38278"
import script from "./ObjectStoreActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreActions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports